import { render, staticRenderFns } from "./HomepageProductWishlist.vue?vue&type=template&id=0fa40709&scoped=true&"
import script from "./HomepageProductWishlist.vue?vue&type=script&lang=js&"
export * from "./HomepageProductWishlist.vue?vue&type=script&lang=js&"
import style0 from "./HomepageProductWishlist.vue?vue&type=style&index=0&id=0fa40709&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa40709",
  null
  
)

export default component.exports